const phone = (value: string): string => {
  if (!value) return ''
  const str = String(value)
  let cleaned = str
  if (str.startsWith('62')) {
    cleaned = str.slice(2)
  }
  // format as +62 XXX XXXX XXXX
  const formatted = cleaned.replace(/(\d{3})(\d{4})(\d{4})/, '$1 $2 $3')
  return `+62 ${formatted}`
}

export default {
  phone,
}
